import * as React from 'react'

import classNames from 'classnames'

import * as styles from './index.vanilla.css'

export type Size = 'small' | 'medium' | 'big' | 'full'
interface Props {
  size?: Size
}

const ScrollableList = (props: React.PropsWithChildren<Props>) => {
  const { children, size = 'small' } = props

  return <div className={classNames(styles.scrollableList, styles[size])}>{children}</div>
}

export default ScrollableList
